import { OvenMediaReceiverWebRTCSessionOptions } from '@kalyzee/kast-webrtc-client-module';

const DEV_ENV_PREFIX = 'REACT_APP_';

export const getEnv = (key: string): string | undefined => {
  let result: string | undefined;
  if (process.env.NODE_ENV === "development") {
    result = process.env[`${DEV_ENV_PREFIX}${key}`];
    if (result !== undefined) {
      return result;
    }
  }
  const customLocalData = (window as any).__custom_local_data__;
  return customLocalData?.[key];
}

// Resolve a configured url that may omit the host. Allow a port-only value
// (e.g. ":8088") so the target is resolved on the same host as the dashboard.
// This keeps it working whether the page is opened via localhost, an IP or a
// domain name.
const resolveEnvUrl = (urlStr: string | undefined): string | undefined => {
  if (!urlStr) return undefined;
  const { protocol, hostname } = window.location;
  if (urlStr.startsWith(':')) {
    // Port-only form: needs the current host to be substituted in. Without a
    // host we would build an invalid "http://:port" url, so bail out instead.
    if (!hostname) return undefined;
    urlStr = `${protocol}//${hostname}${urlStr}`;
  } else if (!urlStr.startsWith('http')) {
    urlStr = `${protocol}//${urlStr}`;
  }
  try {
    const url = new URL(urlStr);
    if (!url.hostname) return undefined;
    return url.href;
  } catch {
    return undefined;
  }
}

export const getEnvApiUrl = () : string | undefined => {
  return resolveEnvUrl(getEnv('API_URL'));
}

export const getEnvPullWebMediaUrl = () : string | undefined => {
  return resolveEnvUrl(getEnv('PULL_WEB_MEDIA_URL'));
}

export const getEnvPushWebMediaUrl = () : string | undefined => {
  return resolveEnvUrl(getEnv('PUSH_WEB_MEDIA_URL'));
}

export const getEnvMultiServer = () : boolean | undefined => {
  return getEnv('MULTI_SERVERS') === "true";
}

export const getEnvConfigSelector = () : boolean => {
  return getEnv('CONFIG_SELECTOR') === "true";
}

export const getEnvRtcOptions = () : OvenMediaReceiverWebRTCSessionOptions | undefined => {
  const raw = getEnv('RTC_OPTIONS') as unknown;
  if (!raw) return undefined;
  // In production (load_env.js) the value can be provided as a plain object,
  // in development (.env) it is a JSON string that needs parsing.
  if (typeof raw === 'object') return raw as OvenMediaReceiverWebRTCSessionOptions;
  try {
    return JSON.parse(raw as string);
  } catch {
    return undefined;
  }
}